import type { SVGProp } from './types';

export const arrowTopRight = (props: SVGProp) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
    <path d="M7.47656 17.7229L16.3154 8.88407" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M17.0215 17.3694V8.577c0-.22092-.1791-.4-.4-.4H7.8291" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
